module.exports = __webpack_public_path__ + "static/img/smartProduct13.6cb254ce.png";